export default function retentionSettingsService($http, $q, RESOURCES) {
  var retentionSettingsSegment = '/retention_settings';

  function getRetentionSettings(merchantId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + retentionSettingsSegment);
  }

  function updateRetentionSettings(merchantId, data) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + retentionSettingsSegment, data);
  }

  return { getRetentionSettings: getRetentionSettings, updateRetentionSettings: updateRetentionSettings };
}



// WEBPACK FOOTER //
// ./src/app/merchants/retention-settings/retention-settings.service.js